import {
  Modal as CModal,
  ModalProps as CModalProps,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalOverlayProps,
} from '@chakra-ui/react';
import { useWindowSize } from 'react-use';
import { useBreakpointValue } from '~/utils-ts';

import { ModalFooter } from './Footer';
import { ModalHeader } from './Header';
import { getStylesBySize } from './utils';

interface ModalProps extends Omit<CModalProps, 'children'> {
  isFullScreenOnMobile?: boolean;
  modalContentProps?: any;
  children?: React.ReactNode;
  overlayProps?: ModalOverlayProps;
}

export const Modal = ({
  isFullScreenOnMobile = false,
  isOpen = false,
  children = null,
  modalContentProps = {},
  overlayProps,
  size,
  ...props
}: ModalProps) => {
  const { height } = useWindowSize(); // Hack for iOS https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  const baseSize = isFullScreenOnMobile ? 'full' : 'fullWidth';
  const modalSize = useBreakpointValue({
    base: baseSize,
    md: size,
    lg: size,
    xl: size,
    '2xl': size,
  }) as string;
  const { containerProps, ...otherModalContentProps } = modalContentProps;
  const { containerPropsBySize = {}, contentPropsBySize = {} } =
    getStylesBySize(modalSize);

  return (
    <CModal
      isCentered
      isOpen={isOpen}
      size={modalSize}
      variant="newMP"
      {...props}
    >
      <ModalOverlay height={height} {...overlayProps} />
      <ModalContent
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="scrollbar-thin"
        containerProps={{ ...containerProps, ...containerPropsBySize }}
        paddingX={4}
        {...contentPropsBySize}
        {...otherModalContentProps}
      >
        {children}
      </ModalContent>
    </CModal>
  );
};

Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.CloseButton = ModalCloseButton;
Modal.Header = ModalHeader;
